module.exports = __webpack_public_path__ + "assets/images/project/nusajaya.jpg?v=9b46b926";